import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { CreateGroupPayload } from "../../payload/CreateGroup/CreateGroupPayload";

const createGroupFetch = (state: GroupsState, action: PayloadAction<CreateGroupPayload>) => {
    state.isLoading = true;
}

export default createGroupFetch;